var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default',{attrs:{"needs-project":""}},[_c('div',{attrs:{"id":"dashboard_main"}},[_c('pre',[_vm._v("            "+_vm._s(_vm.project)+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }